var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveForwarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3541 11.354L11.3541 13.354C11.2603 13.4478 11.1331 13.5006 11.0004 13.5006C10.8677 13.5006 10.7405 13.4478 10.6466 13.354C10.5528 13.2602 10.5001 13.133 10.5001 13.0003C10.5001 12.8676 10.5528 12.7403 10.6466 12.6465L11.7935 11.5003H3.00039C2.86779 11.5003 2.74061 11.4476 2.64684 11.3538C2.55307 11.2601 2.50039 11.1329 2.50039 11.0003C2.50039 10.8677 2.55307 10.7405 2.64684 10.6467C2.74061 10.553 2.86779 10.5003 3.00039 10.5003H11.7935L10.6466 9.35403C10.5528 9.26021 10.5001 9.13296 10.5001 9.00028C10.5001 8.8676 10.5528 8.74035 10.6466 8.64653C10.7405 8.55271 10.8677 8.5 11.0004 8.5C11.1331 8.5 11.2603 8.55271 11.3541 8.64653L13.3541 10.6465C13.4006 10.693 13.4375 10.7481 13.4627 10.8088C13.4878 10.8695 13.5008 10.9346 13.5008 11.0003C13.5008 11.066 13.4878 11.131 13.4627 11.1917C13.4375 11.2524 13.4006 11.3076 13.3541 11.354ZM4.64664 7.35403C4.74046 7.44785 4.86771 7.50056 5.00039 7.50056C5.13308 7.50056 5.26032 7.44785 5.35414 7.35403C5.44796 7.26021 5.50067 7.13296 5.50067 7.00028C5.50067 6.8676 5.44796 6.74035 5.35414 6.64653L4.20727 5.50028H13.0004C13.133 5.50028 13.2602 5.4476 13.3539 5.35383C13.4477 5.26006 13.5004 5.13289 13.5004 5.00028C13.5004 4.86767 13.4477 4.74049 13.3539 4.64672C13.2602 4.55296 13.133 4.50028 13.0004 4.50028H4.20727L5.35414 3.35403C5.44796 3.26021 5.50067 3.13296 5.50067 3.00028C5.50067 2.8676 5.44796 2.74035 5.35414 2.64653C5.26032 2.55271 5.13308 2.5 5.00039 2.5C4.86771 2.5 4.74046 2.55271 4.64664 2.64653L2.64664 4.64653C2.60016 4.69296 2.56328 4.74811 2.53811 4.80881C2.51295 4.86951 2.5 4.93457 2.5 5.00028C2.5 5.06599 2.51295 5.13105 2.53811 5.19175C2.56328 5.25245 2.60016 5.30759 2.64664 5.35403L4.64664 7.35403Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 8,
    height: 8,
    fill: "#F9FAFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_23406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5C12.3807 8.5 13.5 7.38071 13.5 6C13.5 4.61929 12.3807 3.5 11 3.5C9.61929 3.5 8.5 4.61929 8.5 6C8.5 7.38071 9.61929 8.5 11 8.5Z",
    stroke: "#87909B",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.25L10.25 6.75",
    stroke: "#87909B",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5.25L11.75 6.75",
    stroke: "#87909B",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_23406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(8 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveForwarding);
export default __webpack_public_path__ + "static/media/RemoveForwarding.b6d55e2185c971732ea8b4b379f02a3e.svg";
export { ForwardRef as ReactComponent };